export const getNestedProperty = (path, nestedObj, defaultValue = null) => {
  const pathArr = path.split('.');
  return pathArr.reduce(
    (obj, key) => (obj && key in obj ? obj[key] : defaultValue),
    nestedObj,
  );
};
